import React, { useState, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { useDispatch } from 'react-redux';

import api, { setToken } from '../../../../api/api';
import history from "../../../../history";
import { userLogin } from '../../../actions';

import EditProfileForm from '../../../Home/Forms/EditProfileForm';
import ChangePasswordForm from '../../../Home/Forms/ChangePasswordForm';
import ChangeLoginInfoForm from '../../../Home/Forms/ChangeLoginInfoForm';
import UserBill from '../../Users/UserBill';
import UserNote from '../../Users/UserNote';
import countriesData from "../../../Config/countries.json";

const getCountryName = (code) => {
    if (!code) return "";
    const cleanCode = code.toLowerCase();
    const found = countriesData.countries.find(c => c.value === cleanCode || c.alpha3?.toLowerCase() === cleanCode);
    return found ? found.label : code.toUpperCase();
};

const WhatsAppModals = ({
    showAddModal,
    setShowAddModal,
    showEditModal,
    setShowEditModal,
    showUserInfoModal,
    setShowUserInfoModal,
    activeChat,
    userInfoData,
    setUserInfoData,
    loadingUserInfo,
    checkingPhone,
    setCheckingPhone,
    checkResult,
    setCheckResult,
    modalPhone,
    setModalPhone,
    modalCountry,
    setModalCountry,
    modalFirstName,
    setModalFirstName,
    modalLastName,
    setModalLastName,
    handleCheckWhatsApp,
    handleAddContactSubmit,
    handleEditContactSubmit,
    getPhotoUrl,
    getCountryFlag,
    getCountryFromWhatsAppId,
    fetchChats,
    t
}) => {
    const dispatch = useDispatch();

    // Secondary Modal states for UserInfo management options
    const [showEditProfile, setShowEditProfile] = useState(false);
    const [showBills, setShowBills] = useState(false);
    const [showNotes, setShowNotes] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showLoginInfo, setShowLoginInfo] = useState(false);
    const [showChangeSchool, setShowChangeSchool] = useState(false);
    const [showMove, setShowMove] = useState(false);

    // Track if school modal is for general School change, or if it is part of User Type conversion
    const [schoolModalPurpose, setSchoolModalPurpose] = useState("school"); // "school" or "teacherType"

    // Ref for school select
    const schoolSelectRef = useRef(null);
    const classRoomSelectRef = useRef(null);

    // API Helpers
    const filterOptions = (options, inputValue) => {
        const candidate = (inputValue || "").toLowerCase();
        if (options.length > 0) {
            return options.filter(({ label }) => label.toLowerCase().includes(candidate));
        }
        return true;
    };

    const promiseSchoolOptions = (inputValue, callback) => {
        api.post(`/SchoolsLookups/`, {
            Name: inputValue
        }).then(resp => {
            if (resp.data.data?.length > 0) {
                const asyncOptions = resp.data.data.map(({ Id, Name }) => ({ label: Name, value: Id }));
                const filtered = filterOptions(asyncOptions, inputValue);
                callback(filtered);
            } else {
                callback();
            }
        });
    };

    const promiseClassRoomOptions = (inputValue, callback) => {
        if (!userInfoData || !userInfoData.schoolId) {
            callback();
            return;
        }
        api.post(`/ClassRoomsLookups/`, {
            Name: inputValue,
            SchoolId: userInfoData.schoolId
        }).then(resp => {
            if (resp.data.data?.length > 0) {
                const asyncOptions = resp.data.data.map(p => ({ label: p.ClassType.Name + " " + p.Division.Name, value: p.Id }));
                const filtered = filterOptions(asyncOptions, inputValue);
                callback(filtered);
            } else {
                callback();
            }
        });
    };

    // Submissions
    const onSubmitEditProfile = (postData, _toastId) => {
        api.put(`/Users/${userInfoData.id}`, postData)
            .then(response => {
                if (response.data.code === "success") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.ProfileEdit.success_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.success_toast.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowEditProfile(false);
                    // Refresh user info
                    refreshUserInfo();
                } else if (response.data.code === "exists_email") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.Register.Email.error_toast.Title')}</div> <div className="h6">{t('Pages.Register.Email.error_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            })
            .catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            });
    };

    const onSubmitChangePassword = (postData, _toastId) => {
        api.put(`/Users/${userInfoData.id}?ChangePassword=true`, postData)
            .then(response => {
                if (response.data.code === "success") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.ProfileEdit.success_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.success_toast.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowChangePassword(false);
                } else {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            })
            .catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            });
    };

    const onSubmitLoginInfo = (postData) => {
        const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
        api.post(`/ChangeUserLoginInfo/${userInfoData.id}`, postData)
            .then(response => {
                if (response.data.code === "success") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.ProfileEdit.success_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.success_toast.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowLoginInfo(false);
                    refreshUserInfo();
                } else if (response.data.code === "exists_username") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.Register.Username.error_toast.Title')}</div> <div className="h6">{t('Pages.Register.Username.error_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else if (response.data.code === "exists_email") {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.Register.Email.error_toast.Title')}</div> <div className="h6">{t('Pages.Register.Email.error_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            })
            .catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            });
    };

    const handleSchoolSave = () => {
        const selectedValue = schoolSelectRef.current?.select?.select?.getValue()?.[0];
        if (!selectedValue) {
            toast.error(t("Pages.UsersControl.toast.ChangeSchool.error"));
            return;
        }

        const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });

        if (schoolModalPurpose === "teacherType") {
            // Converting User to Teacher with specific school selection
            const postData = {
                SchoolId: selectedValue.value,
                UserTypeId: 4
            };
            api.put(`/ChangeUserType/${userInfoData.id}`, postData)
                .then(response => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.UsersControl.toast.ChangePermission.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.ChangePermission.Body')}</div></div>,
                        type: toast.TYPE.INFO,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowChangeSchool(false);
                    refreshUserInfo();
                })
                .catch(error => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                });
        } else {
            // General school update
            api.post(`/ChangeUserSchool/${userInfoData.id}`, { SchoolId: selectedValue.value })
                .then(response => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-school"></i> {t('Pages.UsersControl.toast.ChangeSchool.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.ChangeSchool.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowChangeSchool(false);
                    refreshUserInfo();
                })
                .catch(error => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                });
        }
    };

    const handleClassRoomSave = () => {
        const selectedValue = classRoomSelectRef.current?.select?.select?.getValue()?.[0];
        if (!selectedValue) {
            toast.error(t("Pages.UsersControl.toast.ChangeClassRoom.error"));
            return;
        }

        const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
        api.post(`/ChangeStudentClass/${userInfoData.id}`, { ClassRoomId: selectedValue.value })
            .then(response => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"><i className="icon fal fa-exchange"></i>{t('Pages.UsersControl.toast.ChangeClassRoom.Title')}</div><div className="h6">{t('Pages.UsersControl.toast.ChangeClassRoom.Body')}</div></div>,
                    type: toast.TYPE.SUCCESS,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
                setShowMove(false);
                refreshUserInfo();
            })
            .catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            });
    };

    // User Operations mirroring UserItem.js
    const changeUserType = () => {
        // Switch between User (2) and Teacher (4) or confirm switch
        if (userInfoData.userTypeId === 4) {
            // Convert teacher back to regular student/user
            if (window.confirm(t("ChangePermissionUserProcessing"))) {
                const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
                api.put(`/ChangeUserType/${userInfoData.id}`, { SchoolId: null, UserTypeId: 2 })
                    .then(() => {
                        toast.update(_toastId, {
                            render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.UsersControl.toast.ChangePermission.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.ChangePermission.Body')}</div></div>,
                            type: toast.TYPE.INFO,
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        refreshUserInfo();
                    })
                    .catch(() => {
                        toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                    });
            }
        } else if (userInfoData.userTypeId === 2) {
            // Convert regular student to school teacher: Needs a school lookup selection modal first
            setSchoolModalPurpose("teacherType");
            setShowChangeSchool(true);
        }
    };

    const changePermission = () => {
        // Toggle Manager (3) and Teacher (4)
        if (window.confirm(t("ChangePermissionUserProcessing"))) {
            const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
            const targetType = userInfoData.userTypeId === 3 ? 4 : 3;
            api.post(`/ChangeUserType/${userInfoData.id}`, { UserTypeId: targetType })
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.UsersControl.toast.ChangePermission.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.ChangePermission.Body')}</div></div>,
                        type: toast.TYPE.INFO,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    refreshUserInfo();
                })
                .catch(() => {
                    toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                });
        }
    };

    const changeAccessToAllClass = () => {
        if (window.confirm(t("ChangeAccessToClassProcessing"))) {
            const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
            api.post(`/ChangeAccessToAllClass/${userInfoData.id}`)
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.UsersControl.toast.ChangePermission.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.ChangePermission.Body')}</div></div>,
                        type: toast.TYPE.INFO,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    refreshUserInfo();
                })
                .catch(() => {
                    toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                });
        }
    };

    const toggleTestUser = () => {
        if (window.confirm(t("TestUserProcessing"))) {
            const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
            api.put(`/UserAsUser/${userInfoData.id}`)
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.UsersControl.toast.test_user.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.test_user.Body')}</div></div>,
                        type: toast.TYPE.INFO,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    refreshUserInfo();
                })
                .catch(() => {
                    toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                });
        }
    };

    const loginAsUser = () => {
        if (window.confirm(t("UserAsProcessing"))) {
            const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
            api.post(`/UserAsUser/${userInfoData.id}`)
                .then(response => {
                    if (response.data.code === "success") {
                        let prevToken = localStorage.getItem('token');
                        localStorage.setItem('prevToken', prevToken);
                        localStorage.setItem('token', response.data.token);
                        dispatch(userLogin(response.data));
                        setToken(response.data.token);

                        toast.update(_toastId, {
                            render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.Login.success_toast.Title')}</div> <div className="h6">{t('Pages.Login.success_toast.Body')}</div></div>,
                            type: toast.TYPE.INFO,
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        setShowUserInfoModal(false);
                        history.push("/Profile");
                    }
                })
                .catch(() => {
                    toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                });
        }
    };

    const deleteUser = () => {
        if (window.confirm(t("DeleteProcessing"))) {
            const _toastId = toast(t('Processing'), { position: "bottom-left", autoClose: false });
            api.delete(`/Users/${userInfoData.id}`)
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-exclamation-triangle"></i> {t('Pages.UsersControl.toast.Delete.Title')}</div> <div className="h6">{t('Pages.UsersControl.toast.Delete.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setShowUserInfoModal(false);
                    fetchChats();
                })
                .catch(() => {
                    toast.update(_toastId, { type: toast.TYPE.ERROR, autoClose: 5000, render: () => <div>{t('Error.NoConnection.Title')}</div> });
                });
        }
    };

    // Re-query user info from backend
    const refreshUserInfo = () => {
        if (!userInfoData || !userInfoData.id) return;
        // Since chatId is formatted as phone@c.us, if it is not present, construct it
        const idStr = String(userInfoData.id);
        const cId = idStr.includes('@') ? idStr : `${userInfoData.phone}@c.us`;
        api.get(`/green/user-info?chatId=${cId}`)
            .then(response => {
                setUserInfoData({
                    ...response.data,
                    photo: response.data.photo || userInfoData.photo || null
                });
            })
            .catch(() => { });
    };

    // Compat User formatting for UserBill/UserNote/EditProfile components
    const compatUser = userInfoData ? {
        Id: userInfoData.id,
        Name: (userInfoData.firstName || '') + ' ' + (userInfoData.lastName || ''),
        FirstName: userInfoData.firstName,
        SecondName: '',
        LastName: userInfoData.lastName,
        Username: userInfoData.username,
        Email: userInfoData.email,
        Phone: userInfoData.phone,
        Country: userInfoData.country,
        Photo: userInfoData.photo,
        Birthday: userInfoData.birthday || '01/01/2000',
        Sex: userInfoData.sex || 'male',
        Address: userInfoData.address || '',
        IsLocked: userInfoData.isLocked,
        IsTeacher: userInfoData.isTeacher || false,
        MaxSubUser: userInfoData.maxSubUser || '',
        UserType: { Id: userInfoData.userTypeId, Name: userInfoData.userTypeName },
        Notes: userInfoData.notesCount || 0
    } : null;

    return (
        <>
            {/* ADD CONTACT MODAL */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Pages.WhatsApp.addContact")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="whatsapp-modal-body">
                        <div className="whatsapp-form-group">
                            <label>{t("Register")}</label>
                            <div className="d-flex gap-2">
                                <select
                                    className="whatsapp-form-input"
                                    style={{ width: '120px' }}
                                    value={modalCountry}
                                    onChange={(e) => setModalCountry(e.target.value)}
                                >
                                    {countriesData.countries
                                        .filter(c => c.phoneCode && c.value)
                                        .map(c => (
                                            <option key={c.id} value={c.value.toLowerCase()}>
                                                {c.value.toUpperCase()} (+{c.phoneCode})
                                            </option>
                                        ))
                                    }
                                </select>
                                <input
                                    type="text"
                                    className="whatsapp-form-input flex-grow-1"
                                    placeholder={t("Pages.WhatsApp.phone")}
                                    value={modalPhone}
                                    onChange={(e) => setModalPhone(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="whatsapp-btn whatsapp-btn-secondary"
                                    onClick={handleCheckWhatsApp}
                                    disabled={checkingPhone || !modalPhone.trim()}
                                >
                                    {checkingPhone ? (
                                        <i className="fa-spin fas fa-spinner"></i>
                                    ) : (
                                        t("Pages.WhatsApp.check")
                                    )}
                                </button>
                            </div>
                        </div>

                        {checkResult !== null && (
                            <div className={`whatsapp-alert ${checkResult ? "whatsapp-alert-success" : "whatsapp-alert-danger"} mt-2`}>
                                {checkResult
                                    ? t("Pages.WhatsApp.checkedSuccess")
                                    : t("Pages.WhatsApp.checkedError")}
                            </div>
                        )}

                        <form onSubmit={handleAddContactSubmit} className="mt-3">
                            <div className="whatsapp-form-group">
                                <label>{t("Pages.WhatsApp.firstNamePlaceholder")}</label>
                                <input
                                    type="text"
                                    className="whatsapp-form-input"
                                    value={modalFirstName}
                                    onChange={(e) => setModalFirstName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="whatsapp-form-group">
                                <label>{t("Pages.WhatsApp.lastNamePlaceholder")}</label>
                                <input
                                    type="text"
                                    className="whatsapp-form-input"
                                    value={modalLastName}
                                    onChange={(e) => setModalLastName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <button type="button" className="whatsapp-btn whatsapp-btn-secondary" onClick={() => setShowAddModal(false)}>
                                    {t("Close")}
                                </button>
                                <button type="submit" className="whatsapp-btn whatsapp-btn-primary" disabled={checkResult === false}>
                                    {t("Pages.UsersControl.notes.Send")}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            {/* EDIT CONTACT NAME MODAL */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Pages.WhatsApp.editContact")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="whatsapp-modal-body">
                        <form onSubmit={handleEditContactSubmit}>
                            <div className="whatsapp-form-group">
                                <label>{t("Pages.WhatsApp.firstNamePlaceholder")}</label>
                                <input
                                    type="text"
                                    className="whatsapp-form-input"
                                    value={modalFirstName}
                                    onChange={(e) => setModalFirstName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="whatsapp-form-group">
                                <label>{t("Pages.WhatsApp.lastNamePlaceholder")}</label>
                                <input
                                    type="text"
                                    className="whatsapp-form-input"
                                    value={modalLastName}
                                    onChange={(e) => setModalLastName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <button type="button" className="whatsapp-btn whatsapp-btn-secondary" onClick={() => setShowEditModal(false)}>
                                    {t("Close")}
                                </button>
                                <button type="submit" className="whatsapp-btn whatsapp-btn-primary">
                                    {t("Pages.UsersControl.notes.Send")}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            {/* USER INFO MODAL */}
            <Modal show={showUserInfoModal} onHide={() => setShowUserInfoModal(false)} centered size="lg" className="text-right">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fad fa-info-circle text-primary ml-2"></i>
                        {t("Pages.WhatsApp.userInfo")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingUserInfo ? (
                        <div className="text-center py-5">
                            <i className="fa-spin fas fa-spinner text-success h3"></i>
                            <p className="mt-2 text-muted">{t("Pages.WhatsApp.loadingUserInfo")}</p>
                        </div>
                    ) : userInfoData ? (
                        <div className="whatsapp-user-info-body text-right">
                            <div className="whatsapp-user-info-avatars d-flex justify-content-center gap-4 mb-4 flex-wrap w-100">
                                {!userInfoData.isWhatsAppOnly && userInfoData.photo && (
                                    <div className="text-center mx-2">
                                        <div className="whatsapp-user-info-avatar">
                                            <img src={getPhotoUrl(userInfoData.photo)} alt={userInfoData.firstName} className="whatsapp-avatar-img" />
                                        </div>
                                        <small className="text-muted d-block mt-2 font-weight-bold">{t("Pages.WhatsApp.dbPhoto") || "صورة النظام"}</small>
                                    </div>
                                )}
                                {userInfoData.whatsappPhoto && (
                                    <div className="text-center mx-2">
                                        <div className="whatsapp-user-info-avatar">
                                            <img src={userInfoData.whatsappPhoto} alt="WhatsApp" className="whatsapp-avatar-img" />
                                        </div>
                                        <small className="text-muted d-block mt-2 font-weight-bold">{t("Pages.WhatsApp.whatsappPhoto") || "صورة واتساب"}</small>
                                    </div>
                                )}
                                {!userInfoData.photo && !userInfoData.whatsappPhoto && (
                                    <div className="whatsapp-user-info-avatar">
                                        {(userInfoData.firstName || "?").substring(0, 1).toUpperCase()}
                                    </div>
                                )}
                            </div>

                            <div className="whatsapp-user-info-details mt-3 text-right">
                                <div className="whatsapp-user-info-row full-width">
                                    <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.dbStatus")}</span>
                                    <span className="whatsapp-user-info-val">
                                        {userInfoData.isWhatsAppOnly ? (
                                            <span className="whatsapp-user-info-status locked">{t("Pages.WhatsApp.unregisteredUser")}</span>
                                        ) : (
                                            <span className="whatsapp-user-info-status active">{t("Pages.WhatsApp.registeredUser")}</span>
                                        )}
                                    </span>
                                </div>
                                <div className="whatsapp-user-info-row">
                                    <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.firstNamePlaceholder")}</span>
                                    <span className="whatsapp-user-info-val">{userInfoData.firstName} {userInfoData.lastName}</span>
                                </div>
                                <div className="whatsapp-user-info-row">
                                    <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.phone")}</span>
                                    <span className="whatsapp-user-info-val" dir="ltr">{userInfoData.phone || String(userInfoData.id)?.split('@')[0]}</span>
                                </div>
                                {userInfoData.country && (
                                    <div className="whatsapp-user-info-row">
                                        <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.country")}</span>
                                        <span className="whatsapp-user-info-val">
                                            <img
                                                src={process.env.PUBLIC_URL + getCountryFlag(userInfoData.country)}
                                                className="country-flag-icon"
                                                title={userInfoData.country}
                                                alt={userInfoData.country}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                            {getCountryName(userInfoData.country)}
                                        </span>
                                    </div>
                                )}
                                {!userInfoData.isWhatsAppOnly && (
                                    <>
                                        <div className="whatsapp-user-info-row">
                                            <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.username")}</span>
                                            <span className="whatsapp-user-info-val">{userInfoData.username}</span>
                                        </div>
                                        <div className="whatsapp-user-info-row full-width">
                                            <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.email")}</span>
                                            <span className="whatsapp-user-info-val">{userInfoData.email}</span>
                                        </div>
                                        {userInfoData.schoolName && (
                                            <div className="whatsapp-user-info-row">
                                                <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.school")}</span>
                                                <span className="whatsapp-user-info-val">{userInfoData.schoolName}</span>
                                            </div>
                                        )}
                                        <div className="whatsapp-user-info-row">
                                            <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.userType")}</span>
                                            <span className="whatsapp-user-info-val">{userInfoData.userTypeName}</span>
                                        </div>
                                        {userInfoData.birthday && (
                                            <div className="whatsapp-user-info-row">
                                                <span className="whatsapp-user-info-label">{t("Pages.Register.Birthday.title") || "تاريخ الميلاد"}</span>
                                                <span className="whatsapp-user-info-val">{userInfoData.birthday}</span>
                                            </div>
                                        )}
                                        {userInfoData.creationDate && (
                                            <div className="whatsapp-user-info-row">
                                                <span className="whatsapp-user-info-label">{t("Pages.Lessons.CreationDate") || t("Pages.WhatsApp.creationDate")}</span>
                                                <span className="whatsapp-user-info-val">{userInfoData.creationDate}</span>
                                            </div>
                                        )}
                                        {userInfoData.updateDate && (
                                            <div className="whatsapp-user-info-row">
                                                <span className="whatsapp-user-info-label">{t("Pages.Lessons.UpdateDate") || "تاريخ التعديل"}</span>
                                                <span className="whatsapp-user-info-val">{userInfoData.updateDate}</span>
                                            </div>
                                        )}
                                        <div className="whatsapp-user-info-row">
                                            <span className="whatsapp-user-info-label">{t("Pages.WhatsApp.status")}</span>
                                            <span className="whatsapp-user-info-val">
                                                {userInfoData.isLocked ? (
                                                    <span className="whatsapp-user-info-status locked">{t("Pages.WhatsApp.locked")}</span>
                                                ) : (
                                                    <span className="whatsapp-user-info-status active">{t("Pages.WhatsApp.active")}</span>
                                                )}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* ACTION GRID mirroring UserItem.js options */}
                            {!userInfoData.isWhatsAppOnly && (
                                <div className="whatsapp-user-info-actions">
                                    {/* 1. EDIT PROFILE */}
                                    {userInfoData.userTypeId !== 7 && (
                                        <button className="whatsapp-action-btn whatsapp-action-edit" onClick={() => setShowEditProfile(true)} title={t("Pages.UsersControl.action.edit")}>
                                            <i className="far fa-edit"></i>
                                            <span>{t("Pages.UsersControl.action.edit")}</span>
                                        </button>
                                    )}

                                    {/* 2. USER BILLS */}
                                    {(userInfoData.userTypeId === 2 || userInfoData.userTypeId === 7) && (
                                        <button className="whatsapp-action-btn whatsapp-action-bills" onClick={() => setShowBills(true)} title={t("Pages.UsersControl.action.bills")}>
                                            <i className="far fa-file-invoice-dollar"></i>
                                            <span>{t("Pages.UsersControl.action.bills")}</span>
                                        </button>
                                    )}

                                    {/* 3. USER NOTES */}
                                    <button className="whatsapp-action-btn whatsapp-action-notes" onClick={() => setShowNotes(true)} title={t("Pages.UsersControl.action.notes")}>
                                        <i className={`far ${userInfoData.notesCount > 0 ? "text-danger fa-notes" : "fa-sticky-note"}`}></i>
                                        <span>{t("Pages.UsersControl.action.notes")}</span>
                                        {userInfoData.notesCount > 0 && <span className="whatsapp-notes-badge">{userInfoData.notesCount}</span>}
                                    </button>

                                    {/* 4. CHANGE PASSWORD */}
                                    {userInfoData.userTypeId !== 7 && (
                                        <button className="whatsapp-action-btn whatsapp-action-password" onClick={() => setShowChangePassword(true)} title={t("Pages.UsersControl.action.change_password")}>
                                            <i className="far fa-key"></i>
                                            <span>{t("Pages.UsersControl.action.change_password")}</span>
                                        </button>
                                    )}

                                    {/* 5. CHANGE LOGIN INFO */}
                                    {userInfoData.userTypeId !== 1 && userInfoData.userTypeId !== 7 && (
                                        <button className="whatsapp-action-btn whatsapp-action-logininfo" onClick={() => setShowLoginInfo(true)} title={t("Pages.UsersControl.action.changeLoginInfo")}>
                                            <i className="far fa-fingerprint text-success"></i>
                                            <span>{t("Pages.UsersControl.action.changeLoginInfo")}</span>
                                        </button>
                                    )}

                                    {/* 6. CHANGE SCHOOL / Swapping type to school teacher */}
                                    {userInfoData.userTypeId === 4 && (
                                        <button className="whatsapp-action-btn whatsapp-action-school" onClick={() => { setSchoolModalPurpose("school"); setShowChangeSchool(true); }} title={t("Pages.UsersControl.action.changeSchool")}>
                                            <i className="far fa-school text-primary"></i>
                                            <span>{t("Pages.UsersControl.action.changeSchool")}</span>
                                        </button>
                                    )}

                                    {/* 7. MAKE SCHOOL TEACHER / MAKE SCHOOL MANAGER */}
                                    {userInfoData.userTypeId === 2 && (
                                        <button className="whatsapp-action-btn whatsapp-action-permission" onClick={changeUserType} title={t("Pages.UsersControl.action.changeTypeToSchoolTeacher")}>
                                            <i className="far fa-chalkboard-teacher text-warning"></i>
                                            <span>{t("Pages.UsersControl.action.changeTypeToSchoolTeacher")}</span>
                                        </button>
                                    )}
                                    {userInfoData.userTypeId === 4 && (
                                        <button className="whatsapp-action-btn whatsapp-action-permission" onClick={changeUserType} title={t("Pages.UsersControl.action.changeTypeToUser")}>
                                            <i className="far fa-user-tag text-warning"></i>
                                            <span>{t("Pages.UsersControl.action.changeTypeToUser")}</span>
                                        </button>
                                    )}
                                    {userInfoData.userTypeId === 3 && (
                                        <button className="whatsapp-action-btn whatsapp-action-permission" onClick={changePermission} title={t("Pages.UsersControl.action.makeSchoolTeacher")}>
                                            <i className="fad fa-water-lower text-danger"></i>
                                            <span>{t("Pages.UsersControl.action.makeSchoolTeacher")}</span>
                                        </button>
                                    )}
                                    {userInfoData.userTypeId === 4 && (
                                        <button className="whatsapp-action-btn whatsapp-action-permission" onClick={changePermission} title={t("Pages.UsersControl.action.makeSchoolManager")}>
                                            <i className="fad fa-water-rise text-danger"></i>
                                            <span>{t("Pages.UsersControl.action.makeSchoolManager")}</span>
                                        </button>
                                    )}

                                    {/* 8. ACCESS TO ALL CLASSES */}
                                    {(userInfoData.userTypeId === 3 || userInfoData.userTypeId === 4) && (
                                        <button className="whatsapp-action-btn whatsapp-action-classes" onClick={changeAccessToAllClass} title={t("Pages.UsersControl.action.accessToAllClass")}>
                                            <i className="fa-solid fa-users-between-lines text-primary"></i>
                                            <span>{t("Pages.UsersControl.action.accessToAllClass")}</span>
                                        </button>
                                    )}

                                    {/* 9. MOVE STUDENT CLASS ROOM */}
                                    {userInfoData.userTypeId === 5 && (
                                        <button className="whatsapp-action-btn whatsapp-action-move" onClick={() => setShowMove(true)} title={t("Pages.StudentInClassRoomsControl.action.move")}>
                                            <i className="far fa-exchange text-warning"></i>
                                            <span>{t("Pages.StudentInClassRoomsControl.action.move")}</span>
                                        </button>
                                    )}

                                    {/* 10. TEST USER */}
                                    {userInfoData.userTypeId === 2 && (
                                        <button className="whatsapp-action-btn whatsapp-action-testuser" onClick={toggleTestUser} title={t("Pages.UsersControl.action.testUser")}>
                                            <i className="fad fa-alarm-exclamation text-danger"></i>
                                            <span>{t("Pages.UsersControl.action.testUser")}</span>
                                        </button>
                                    )}

                                    {/* 11. USE AS */}
                                    {userInfoData.userTypeId !== 7 && (
                                        <button className="whatsapp-action-btn whatsapp-action-useas" onClick={loginAsUser} title={t("Pages.UsersControl.action.useAs") + userInfoData.firstName}>
                                            <i className="fad fa-alien text-info"></i>
                                            <span>{t("Pages.UsersControl.action.useAs")}</span>
                                        </button>
                                    )}

                                    {/* 12. DELETE USER */}
                                    {userInfoData.userTypeId !== 7 && (
                                        <button className="whatsapp-action-btn whatsapp-action-delete" onClick={deleteUser} title={t("Pages.UsersControl.action.remove")}>
                                            <i className="far fa-trash text-danger"></i>
                                            <span>{t("Pages.UsersControl.action.remove")}</span>
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center py-4 text-muted">
                            {t("Pages.WhatsApp.userNotFound")}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="whatsapp-btn whatsapp-btn-secondary" onClick={() => setShowUserInfoModal(false)}>
                        {t("Close")}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* COMPAT MODALS TRIGGERED DYNAMICALLY */}
            {compatUser && (
                <>
                    {/* Bills history modal */}
                    {showBills && (
                        <UserBill handleClose={() => setShowBills(false)} user={compatUser} />
                    )}

                    {/* Notes manager modal */}
                    {showNotes && (
                        <UserNote handleClose={() => { setShowNotes(false); refreshUserInfo(); }} user={compatUser} />
                    )}

                    {/* Edit Profile Form Modal */}
                    {showEditProfile && (
                        <Modal size="lg" centered backdrop="static" show={showEditProfile} onHide={() => setShowEditProfile(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-edit text-primary icon"></i> {t("Pages.UsersControl.action.edit")}:
                                        <span className="text-primary mx-1">{compatUser.Name}</span>
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category">
                                    <div className="widget-body">
                                        <EditProfileForm isAdmin={true} user={compatUser} onSubmit={onSubmitEditProfile} />
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {/* Change Password Modal */}
                    {showChangePassword && (
                        <Modal size="md" centered backdrop="static" show={showChangePassword} onHide={() => setShowChangePassword(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-key text-primary icon"></i> {t("Pages.UsersControl.action.change_password")}:
                                        <span className="text-primary mx-1">{compatUser.Name}</span>
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category">
                                    <div className="widget-body">
                                        <ChangePasswordForm onSubmit={onSubmitChangePassword} />
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {/* Change Login Info Modal */}
                    {showLoginInfo && (
                        <Modal size="md" centered backdrop="static" show={showLoginInfo} onHide={() => setShowLoginInfo(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-fingerprint text-success icon"></i> {t("Pages.UsersControl.action.changeLoginInfo")}:
                                        <span className="text-primary mx-1">{compatUser.Name}</span>
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category">
                                    <div className="widget-body">
                                        <ChangeLoginInfoForm onSubmit={onSubmitLoginInfo} user={compatUser} />
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {/* Change School Modal */}
                    {showChangeSchool && (
                        <Modal size="md" centered backdrop="static" show={showChangeSchool} onHide={() => setShowChangeSchool(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-school text-primary icon"></i>
                                        {schoolModalPurpose === "teacherType" ? (
                                            t("Pages.UsersControl.action.changeTypeToSchoolTeacher")
                                        ) : (
                                            <>
                                                {t("Pages.UsersControl.action.changeSchool")}:
                                                <span className="text-primary mx-1">{compatUser.Name}</span>
                                            </>
                                        )}
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category mb-2">
                                    <div className="widget-body">
                                        <div className="form-group w-100">
                                            <AsyncSelect
                                                cacheOptions
                                                isClearable={true}
                                                name="SchoolsId"
                                                placeholder={t('Pages.UsersControl.advancedSearch.School')}
                                                isRtl={true}
                                                isSearchable={true}
                                                defaultOptions
                                                loadOptions={promiseSchoolOptions}
                                                ref={schoolSelectRef}
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#92278f',
                                                        primary: '#92278f',
                                                    },
                                                })}
                                            />
                                        </div>
                                        <div className="form-group w-100 text-center">
                                            <button className="custom-button" onClick={handleSchoolSave}>
                                                <span>
                                                    <i className="icon fal fa-save"></i> {t('Pages.UsersControl.notes.Send')}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {/* Move Class Room Modal */}
                    {showMove && (
                        <Modal size="md" centered backdrop="static" show={showMove} onHide={() => setShowMove(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-exchange text-primary icon"></i>
                                        {t("Pages.StudentInClassRoomsControl.action.move")}
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category mb-2">
                                    <div className="widget-body">
                                        <div className="form-group w-100">
                                            <AsyncSelect
                                                cacheOptions
                                                isClearable={true}
                                                name="ClassRoomId"
                                                placeholder={t('Pages.ClassRoomsControl.title')}
                                                isRtl={true}
                                                isSearchable={true}
                                                defaultOptions
                                                loadOptions={promiseClassRoomOptions}
                                                ref={classRoomSelectRef}
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#92278f',
                                                        primary: '#92278f',
                                                    },
                                                })}
                                            />
                                        </div>
                                        <div className="form-group w-100 text-center">
                                            <button className="custom-button" onClick={handleClassRoomSave}>
                                                <span>
                                                    <i className="icon fal fa-exchange"></i> {t('Pages.StudentInClassRoomsControl.action.move_action')}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}
                </>
            )}
        </>
    );
};

export default WhatsAppModals;
